import { ApiClient } from '../../ApiClient';
import { EventDTO, CreateEventRequestDTO, UpdateEventRequestDTO } from '../dto/EventDTO';

export class EventDataSource {
  constructor(private api: ApiClient) {}

  async getEvents(): Promise<EventDTO[]> {
    try {
      const response = await this.api.get<EventDTO[]>('/events');
      return response.data;
    } catch (error) {
      console.error('Error fetching events:', error);
      return [];
    }
  }

  async getEvent(id: string): Promise<EventDTO | undefined> {
    try {
      const response = await this.api.get<EventDTO>(`/events/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching event:', error);
      return undefined;
    }
  }

  async createEvent(event: CreateEventRequestDTO): Promise<EventDTO> {
    try {
      const response = await this.api.post<EventDTO>('/events', event);
      return response.data;
    } catch (error) {
      console.error('Error creating event:', error);
      throw error;
    }
  }

  async updateEvent(id: string, event: UpdateEventRequestDTO): Promise<EventDTO> {
    try {
      const response = await this.api.patch<EventDTO>(`/events/${id}`, event);
      return response.data;
    } catch (error) {
      console.error('Error updating event:', error);
      throw error;
    }
  }

  async deleteEvent(id: string): Promise<void> {
    try {
      await this.api.delete(`/events/${id}`);
    } catch (error) {
      console.error('Error deleting event:', error);
      throw error;
    }
  }

  async getEventProducts(eventId: string): Promise<string[]> {
    try {
      const response = await this.api.get<string[]>(`/events/${eventId}/products`);
      return response.data;
    } catch (error) {
      console.error('Error fetching event products:', error);
      return [];
    }
  }

  async linkProduct(eventId: string, productIds: string[]): Promise<void> {
    try {
      await this.api.post(`/events/${eventId}/products`, { productIds });
    } catch (error) {
      console.error('Error linking product:', error);
      throw error;
    }
  }

  async unlinkProduct(eventId: string, productIds: string[]): Promise<void> {
    try {
      await this.api.delete(`/events/${eventId}/products`, { data: { productIds } });
    } catch (error) {
      console.error('Error unlinking product:', error);
      throw error;
    }
  }

  async getProductEvents(productId: string): Promise<EventDTO[]> {
    try {
      const response = await this.api.get<EventDTO[]>(`/events/product/${productId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching product events:', error);
      return [];
    }
  }
}

